/**
 * 表示設定 API クライアント
 */

import { authFetch, API_BASE_URL } from "./client";

/** 表示設定レスポンスの型 */
export interface DisplaySettingResponse {
    id: number;
    company_id: number;
    setting_key: string;
    setting_value: string;
    created_at: string;
    updated_at: string;
}

/** 設定キー定数 */
export const SETTING_KEYS = {
    MONTHLY_SHIFT_CELL: "monthly_shift_cell",
    DAILY_SHIFT_CELL: "daily_shift_cell",
} as const;

/**
 * 表示設定を取得
 * @returns 設定値 (JSON文字列) or null (未設定)
 */
export const fetchDisplaySetting = async (
    companyId: number,
    settingKey: string,
): Promise<string | null> => {
    const response = await authFetch(
        `${API_BASE_URL}/display-settings/${companyId}/${settingKey}`,
    );
    if (response.status === 404) {
        return null;
    }
    if (!response.ok) {
        throw new Error(`Failed to fetch display setting: ${response.status}`);
    }
    const data: DisplaySettingResponse = await response.json();
    return data.setting_value;
};

/**
 * 表示設定を保存 (upsert)
 */
export const saveDisplaySetting = async (
    companyId: number,
    settingKey: string,
    settingValue: string,
): Promise<DisplaySettingResponse> => {
    const response = await authFetch(
        `${API_BASE_URL}/display-settings/${companyId}/${settingKey}`,
        {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ setting_value: settingValue }),
        },
    );
    if (!response.ok) {
        throw new Error(`Failed to save display setting: ${response.status}`);
    }
    return response.json();
};
